export var compLettersBeforeNumbers = function compLettersBeforeNumbers(str1, str2) {
  var s1 = str1 !== null && str1 !== void 0 ? str1 : "";
  var s2 = str2 !== null && str2 !== void 0 ? str2 : "";
  var str1IsNum = /^\d/.test(s1);
  var str2IsNum = /^\d/.test(s2);
  if (str1IsNum !== str2IsNum) return str1IsNum ? 1 : -1;
  return s1.localeCompare(s2);
};